import { lazy } from "react";

// FE-34: Sayfalar ayrı parçalar (chunk) hâlinde, ilk açıldıklarında yüklenir. Yeni sürüm yayınlanınca açık
// sekmedeki eski parça adresi artık sunucuda olmayabilir (ChunkLoadError): sayfa BİR kez yenilenir, yeni
// sürümün parçaları gelir. Yenilemeden sonra da yüklenemezse hata normal şekilde fırlatılır.
const KEY = "chunkReloaded";

export default function lazyWithRetry(factory) {
  return lazy(() =>
    factory()
      .then((mod) => {
        try { sessionStorage.removeItem(KEY); } catch (e) { /* yoksay */ }
        return mod;
      })
      .catch((err) => {
        let reloaded = false;
        try { reloaded = sessionStorage.getItem(KEY) === "1"; } catch (e) { /* yoksay */ }
        if (!reloaded) {
          try { sessionStorage.setItem(KEY, "1"); } catch (e) { /* yoksay */ }
          window.location.reload();
          return new Promise(() => {});
        }
        throw err;
      })
  );
}
